<template>
  <div v-if="userStore.user && userAuthInfo" class="container mol-typical-page-container-20 text-center">
    <div class="row">
      <div class="col-12">
        <h1>Settings</h1>
        <hr>
      </div>
    </div>

    <div class="row">

<!-- profile card -->
      <div class="col-12 col-lg-6">
        <div class="card profile-card">
          <div class="card-header">
            <h2>Profile</h2>
          </div>

          <div class="card-body">
            <div class="profile-pic">
                <EditableProfilePicture :user=userStore.user :size="100" :editable="true"></EditableProfilePicture>
            </div>
            <div class="name-text">
              <b>username</b>
              <br>
              <EditableProfileName></EditableProfileName>
            </div>

            <div class="public-profile-section">
              <b>sharable <i class="fa fa-share-alt"/></b>

              <div class="public-profile-toggle">
                <div class="form-check form-switch text-secondary">
                  <input class="form-check-input" type="checkbox" role="switch" id="profilePrivacyToggle" v-model="publicProfileTogglePosition">
                  <label class="form-check-label" for="profilePrivacyToggle">{{userStore.user.publicProfile ? 'on' : 'off'}}</label>
                </div>
              </div>

              <div class="public-profile-toggle-description">
                When you create your account, your profile page, with the films you've seen and the achievements you've earned, is only visible to you and your friends.<br>Making it public allows you to share it with everyone—even people who don't have myOscarList accounts.<br>Personal account information, like your email, is <u>never</u> shared with <u>anyone</u>.
              </div>

            </div>
          </div>
        </div>
      </div>

<!-- account card -->
      <div class="col-12 col-lg-6">
        <div class="card account-card">
          <div class="card-header">
            <h2>Account</h2>
          </div>

          <div class="card-body">

            <div class="name-text">
              <b>registered email</b>
              <br>
              {{userAuthInfo.email}}
            </div>

            <div class="name-text">
              <b>password</b>
              <br>
              <router-link class="edit-password" href="#" title="update password" to="/reset-password">
                <span v-text="userAuthInfo.isEmailAuthed? 'change password' : 'set password'" aria-hidden="true"></span><i class="fa fa-pencil-square-o"></i>
              </router-link>
            </div>

            <div class="name-text">
              <b>account created</b>
              <br>
              {{this.userAuthInfo.accountCreatedDate.toLocaleDateString()}}
            </div>

            <!-- rolls section -->
            <div v-if="isAdmin || isTester" class="name-text">
              <b>special roles</b>
              <br>
              <div v-if="isAdmin" class="admin-text"><i class="fa fa-wrench"></i> admin</div>
              <div v-if="isTester" class="tester-text"><i class="fa fa-heartbeat"></i> tester</div>
              <div v-if="isFullMember" class="full-member-text"><i class="fa fa-bookmark"></i> full member</div>
            </div>

            <!-- membership section -->
            <div v-if="!waitingForResponse" class="name-text">
              <b>membership</b>
              <br>
              <!-- member? show membership info -->
              <div v-if="myMembership">

                <FamilyMembership v-if="myMembership.lookup_key === 'family-membership'" :membership="myMembership" @membership-updated="populateMembership()"></FamilyMembership>
                <router-link class="membership-name" to="/membership">{{myMembership.name}}</router-link>

              </div>
              <!-- not a member? show link to more info -->
              <div v-else>
                <router-link class="btn btn-sm btn-mol btn-membership-details" to="/membership">
                  <img class="button-icon" :src="`${$imagePathBase}logo-white.svg`"/> Learn About Membership
                </router-link>
              </div>

              <br>
            </div>


          </div>

        </div>
      </div>

      <!-- display card -->
      <div class="col-12 col-lg-6">
        <div class="card display-card">
          <div class="card-header">
            <h2>Display</h2>
          </div>

          <div class="card-body">
            <!--            <div class="color-theme-title"><b>light mode / dark mode</b></div>-->
            <div class="btn-group btn-group-color-theme" role="group" aria-label="color theme button group">
              <input type="radio" class="btn-check" name="btnradio" id="color-theme-light" value="light" v-model="colorThemeChoice">
              <label class="btn btn-outline-mol" for="color-theme-light"> <i class="fa fa-sun-o" aria-hidden="true"></i><br>light mode</label>

              <input type="radio" class="btn-check" name="btnradio" id="color-theme-auto" value="auto" v-model="colorThemeChoice" >
              <label class="btn btn-outline-mol" for="color-theme-auto"> <i class="fa fa-sun-o" aria-hidden="true"></i> <i class="fa fa-moon-o" aria-hidden="true"></i><br>system default</label>

              <input type="radio" class="btn-check" name="btnradio" id="color-theme-dark" value="dark" v-model="colorThemeChoice">
              <label class="btn btn-outline-mol" for="color-theme-dark"><i class="fa fa-moon-o" aria-hidden="true"></i><br>dark mode</label>
            </div>

          </div>
        </div>
      </div>


      <!-- data card -->
      <div class="col-12 col-lg-6">
        <div class="card data-card">
          <div class="card-header">
            <h2>Data</h2>
          </div>

          <div class="card-body">

            <ColorThemeImg class="letterboxd-img" :src="`${$imagePathBase}logos/letterboxd/letterboxd-logo-h-pos-rgb.svg`" :dark_theme_src="`${$imagePathBase}logos/letterboxd/letterboxd-logo-h-neg-rgb.svg`"/>

            <p>
              Full members who have an account with the popular movie social media site <i>Letterboxd</i>, you can import the films you've already marked as<span class="letterboxd-watched"><img :src="`${$imagePathBase}logos/letterboxd/watched.svg`" style="padding-right: 2px;">watched,</span>as well as films on your<span class="letterboxd-watched"><img :src="`${$imagePathBase}logos/letterboxd/watchlist.svg`">watchlist.</span>
            </p>

            <router-link class="btn btn-sm btn-outline-primary" to="/letterboxd">
              <ColorThemeImg class="button-icon" :src="`${$imagePathBase}logos/letterboxd/letterboxd-decal-dots-pos-rgb.svg`" :dark_theme_src="`${$imagePathBase}logos/letterboxd/letterboxd-decal-dots-neg-rgb.svg`"/> Learn More About Importing from Letterboxd
            </router-link>

          </div>
        </div>
      </div>

      <!-- privacy settings card -->
      <div class="col-12 col-lg-6">
        <div class="card privacy-settings-card">
          <div class="card-header">
            <h2><img :src="`${$imagePathBase}about/cookie.svg`" alt="cookie" class="cookie-image">Cookies</h2>
          </div>

          <div class="card-body">
            <CookieSettings></CookieSettings>
          </div>
        </div>
      </div> <!-- privacy card -->

    </div> <!-- row -->


    <hr>
    <table class="version-info">
      <tbody>
        <tr>
          <th>frontend build</th>
          <td>v{{frontendBuildVersion}}</td>
        </tr>
        <tr>
          <th>server build</th>
          <td>v{{serverBuildVersion}}</td>
        </tr>
      </tbody>
    </table>


  </div> <!-- container -->

</template>


<script>
import axios from "axios";
import {userStore} from "@/userStore";
import EditableProfilePicture from "@/components/profile/EditableProfilePicture.vue";
import EditableProfileName from "@/components/profile/EditableProfileName.vue";
import analytics from "@/analytics";
import CookieSettings from "@/components/about/CookieSettings.vue";
import FamilyMembership from "@/components/membership/FamilyMembershipWidget.vue";
import ColorThemeImg from "@/components/ColorThemeImg.vue";

export default {
  components: {ColorThemeImg, FamilyMembership, CookieSettings, EditableProfileName, EditableProfilePicture},
  name: "SettingsPage",
  computed: {
    userStore() {
      return userStore;
    },
    isFullMember() {
      return userStore.isFullMember();
    },
    isAdmin() {
      return userStore.isAdmin();
    },
    isTester() {
      return userStore.isTester();
    }
  },
  data() {
    return {
      waitingForResponse: false,
      userAuthInfo: null,
      showCropper: false,
      sendAnalyticsData: analytics.hasOptedInToTracking(),
      frontendBuildVersion: document?.documentElement?.dataset?.molFrontendBuildVersion,
      serverBuildVersion: null,
      myMembership: null,
      colorThemeChoice: this.$colorTheme.getStoredTheme(),
      publicProfileTogglePosition: userStore.user.publicProfile,
    }
  },
  watch: {
    sendAnalyticsData(newValue) {
      if ( newValue === true ) {
        analytics.optInToTracking();
      } else {
        analytics.optOutOfTracking();
      }
    },
    colorThemeChoice(newValue) {
      this.$colorTheme.setTheme(newValue);
    },
    publicProfileTogglePosition(newValue) {
      const newSettingParam = newValue ? 'true' : 'false';
      axios.post(`/api/user/set-profile-pubic/${newSettingParam}`)
          .then(response => {
            userStore.setUser(response.data);
          });
    }
  },
  async created() {
    this.waitingForResponse = true;
    return axios.get("/api/user/auth-info")
        .then(response => {
          this.serverBuildVersion = response.headers['x-mol-server-build-version'];
          this.userAuthInfo = response.data;

          const kMonthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
          const creationDateObj = new Date(this.userAuthInfo.accountCreatedDate);
          this.userAuthInfo.accountCreatedDate = creationDateObj;
          this.userAuthInfo.accountCreatedDateText = `${kMonthNames[creationDateObj.getMonth()]} ${creationDateObj.getFullYear()}`;
          // console.log(response.data);

          return this.populateMembership();
        })
        .catch(error => {
          analytics.notifyBugsnagOfError(error);
        })
        .finally(() => {
          this.waitingForResponse = false;
        });
  },
  methods: {
    showUpdateUsernameModal() {
      this.editUsername = userStore.user.username;
      this.updateUsernameModal?.show();
    },

    async populateMembership() {

      return axios.get(`/api/membership/my-membership`,{
        validateStatus: status => status < 500 // we want to handle the 400s deliberately
      })
          .then(subscriptionResponse => {
            this.myMembership = (subscriptionResponse.status < 300) ? subscriptionResponse.data : null;
            //console.log('myMembership', this.myMembership);
          });
    },
    async openCustomerPortal() {
      axios.post('/api/membership/stripe/create-customer-portal-session', {
        return_url: this.$route.path
      })
          .then(response => {
            window.location.href = response.data;
          })
          .catch(err => {
            console.log(err);
          });
    }
  }
}
</script>


<style scoped>

.version-info {

  color: grey;
  margin: 20px auto 20px auto;

  font-style: italic;
  th {
    font-weight: inherit;
    text-align: right;
    padding-right: 0.2em;
  }
}

.card {
  margin-top: 20px;
  margin-bottom: 20px;
}

.name-text {
  margin: 1em;
}

.profile-card {

  padding-bottom: 20px;

  .profile-pic {
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
    width: fit-content;
  }

  .public-profile-section {

    border-style: solid;
    border-width: thin;
    border-radius: 5px;
    border-color: var(--bs-border-color);
    padding: 1em;
    width: 90%;
    margin: 50px auto 0 auto;

    .public-profile-toggle {

      /*padding: 2em 1em 0 1em;*/
      font-weight: bold;

      margin-right: auto;
      margin-left: auto;
      width: fit-content;

      .form-switch {
        text-align: center;
        margin: 0;

        .form-check-label {
          font-weight: normal;
          color: var(--mol-color-gold);
          &:hover {
            color: var(--bs-link-hover-color);
          }
        }

        .form-check-input {
          border-color: var(--mol-color-gold);
        }
      }
    }

    .public-profile-toggle-description {
      margin-top: 1em;
      margin-bottom: 1em;
      color: var(--bs-secondary-color);
      font-size: 80%;
    }
  }
}

.display-card {
  padding-bottom: 20px;

  .card-body {
    padding-top: 30px;
  }

}

.account-card {

  .admin-text {
    color: crimson;
  }
  .tester-text {
    color: blue;
  }
  .full-member-text {
    color: var(--mol-color-red-carpet)
  }

  .edit-password {

    border-radius: 1em;
    border-style: solid;
    border-width: 1px;
    border-color: var(--bs-card-border-color);
    padding: 0em 0.4em 0.2em 0.4em;

    text-decoration: inherit;
    color: grey;
    cursor: pointer;

    i {
      margin-top: -0.5ex;
      margin-left: 0.2em;
      position: absolute;
      text-shadow:  -1px -1px 0px white;
      color: var(--bs-card-border-color);
    }

    &:hover {
      color: dimgrey;
      border-color: dimgrey;

      i {
        color: dimgrey;
      }

    }
  }

  .btn-membership-details {
    position: relative;
    img {
      vertical-align: text-bottom;
      height: 1.5em;
    }

    font-weight: bold;


    /*
    color: var(--mol-color-win-icon);
    border-color: var(--mol-color-win-icon);

    &:hover {
      color: var(--mol-color-gold);
    }
     */
  }


  .membership-status {

    /* image of membership icon */
    img {
      vertical-align: text-bottom;
      height: 0.1275em;
      margin-right: 3px;
    }

    .membership-note-badge {

      color: grey;
      font-size: 70%;

      vertical-align: super;

      &::before {
        content: "\00a0(";
      }
      &::after {
        content: ")"
      }

      /*
      white-space: nowrap;
      vertical-align: text-top;
      color: rgb(79, 86, 107);
      background-color: rgb(227, 232, 238);

      padding: 0 0.3em 0 0.3em;
      margin-left: 0.3em;

      font-size: 70%;
      font-weight: 500;

      border-radius: 5px;
      border-style: solid;
      border-width: 1px;
      border-color: rgb(227, 232, 238);

       */
    }
  }


  .manage-membership {

    margin-top: 0.3em;
    border-radius: 1em;
    border-style: solid;
    border-width: 1px;
    border-color: var(--bs-card-border-color);
    padding: 0em 0.4em 0.2em 0.4em;

    text-decoration: inherit;
    color: grey;
    cursor: pointer;

    i {
      margin-top: -0.5ex;
      margin-left: 0.2em;
      position: absolute;
      text-shadow:  -1px -1px 0px white;
      color: var(--bs-card-border-color);
    }

    /* image of membership icon */
    img {
      vertical-align: text-bottom;
      height: 0.1275em;
      margin-right: 3px;
    }

    &:hover {
      color: dimgrey;
      border-color: dimgrey;

      i {
        color: dimgrey;
      }
    }

    &.learn-about-membership {
      color: var(--mol-color-gold);
      border-color: var(--mol-color-gold);

      &:hover {
        border-color: var(--mol-color-win-icon);
      }
    }
  }

  .membership-name {
    font-style: italic;
    color: var(--mol-color-gold-text);
    text-decoration: inherit;
    &:hover {
      color: var(--bs-link-hover-color);
    }
  }

}

.data-card {

  :deep(.letterboxd-img) {
    height: 40px;
  }

  :deep(.button-icon) {
    vertical-align: text-bottom;
    height: 1.5em;
  }

  .letterboxd-watched {
    /*
    color: #bcd;
    background-color: #556677;
     */

    white-space: nowrap;

    font-size: 80%;
    font-weight: 600;
    text-transform: uppercase;
    /*border: solid;*/
    border-color: #dcdcdc;
    border-width: 1px;
    border-radius: 3px;
    padding: 1.5px 5px 3px 5px;

    letter-spacing: 0.075em;

    img {
      vertical-align: text-bottom;
      height: 1.2em;
    }
  }

}

.privacy-settings-card {
  .cookie-image {
    padding: 0px 5px 5px 5px;
    position: relative;
    height: 50px;
  }
}

.color-theme-title {
  margin-bottom: 0.375em;
}

.btn-group-color-theme {
  margin-left: auto;
  margin-right: auto;

  max-width: 80%;
}


</style>